<script lang="ts">
    import * as Table from '@/components/ui/table/index.js';
    import type { Column, Sorter } from './index.js';
    import { ArrowUpDownIcon, SortAscIcon, SortDescIcon } from 'lucide-svelte';
    import { Button } from '../ui/button/index.js';

    type Props = {
        column: Column;
        sorter?: Sorter | null;
        sortCol: () => void;
    };
    let { column = $bindable(), sorter, sortCol }: Props = $props();
</script>

{#if column.sortable}
    <Table.Head class="text-center">
        <Button
            variant="ghost"
            onclick={() => (column.sortable ? sortCol() : null)}
            disabled={!column.sortable}
            class="flex h-full w-full cursor-pointer items-center justify-start gap-2 px-0 pt-4 pb-1 [&_svg]:size-4 "
        >
            <h2 class="text-md"> {column.label ?? column.key}  </h2>
            {#if column.sortable}
                {#if sorter?.key != column.key}
                    <ArrowUpDownIcon></ArrowUpDownIcon>
                {:else if sorter.dir === 'asc'}
                    <SortAscIcon class="text-primary"></SortAscIcon>
                {:else}
                    <SortDescIcon class="text-primary"></SortDescIcon>
                {/if}
            {/if}
        </Button>
    </Table.Head>
{:else}
    <Table.Head class="pt-2 pb-1 text-center">
        <div class="flex">
            <h2 class="text-md"> {column.label ?? column.key} </h2>
        </div>
    </Table.Head>
{/if}
